import React from "react"
import { templatePropTypes } from "../constants"
import Logo from "./Logo"
import MainImage from "./MainImage"
import NewsText from "./NewsText"
import BottomAd from "./BottomAd"
import AdfoxFull from "./adfox/AdfoxFull"
import AdfoxToPad_full from "./adfox/AdfoxToPad_full"
import AdfoxTGB1_MT_Full from "./adfox/AdfoxTGB1_MT_Full"
import AdfoxToPad_prev from "./adfox/AdfoxToPad_prev"
import AdfoxTGB1_MT from "./adfox/AdfoxTGB1_MT"
import AdfoxIR1_full from "./adfox/AdfoxIR1_full"
import AdfoxTGB2_MT_Full from "./adfox/AdfoxTGB2_MT_Full"
import AdfoxIR1_prev from "./adfox/AdfoxIR1_prev"
import AdfoxTGB2_MT from "./adfox/AdfoxTGB2_MT"
import AdfoxAA1_prev from "./adfox/AdfoxAA1_prev"
import AdfoxTGB3_MT from "./adfox/AdfoxTGB3_MT"
import Sidebar from "./Sidebar"
import SmiWidget14849 from "./SmiWidget14849"
import SmiWidget14885 from "./SmiWidget14885"
import SmiWidget14886 from "./SmiWidget14886"
import SmiWidget14890 from "./SmiWidget14890"
import SmiWidget18083 from "./SmiWidget18083"
import SmiWidget28184 from "./SmiWidget28184"
import SmiWidget28185 from "./SmiWidget28185"
import SmiWidget28186 from "./SmiWidget28186"
import SmiWidget28187 from "./SmiWidget28187"
import SmiWidget28691 from "./SmiWidget28691"
import SmiWidget29047 from "./SmiWidget29047";
import SmiJs from "./SmiJs"
import RedirectToBack from "./RedirectToBack"
import BlurReload from "../utils/blurReload"
import BackClick from "./BackClick";
import Popup from "./Popup";
import Footer from "../template900/Footer";
import PlazkartPlayer from "./PlazkartPlayer";


export default class Template2001Component extends React.Component {
    state = {
        isFull: false,
        showFooter: false
    }
    handleScroll = this.handleScroll.bind(this);

    componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

    handleScroll() {
        const elementToScrollTo = document.getElementById('look-also')
        const scrollPosition = window.scrollY + window.innerHeight;
        const elementOffset = elementToScrollTo.offsetTop + elementToScrollTo.offsetHeight + 600;
        if (scrollPosition > elementOffset && !this.state.showElement) {
            this.setState({showFooter: true})
        } else {
            this.setState({ showFooter: false });
        }
    }

    toggleAdfox = () => {
        this.setState({ isFull: true })
    }

    render() {
        const { news, data, onTeaserClick, context } = this.props
        const url = new URL(window.location.href)
        const mt = url.pathname.includes("news/mt/")
        const fprVersion = url.searchParams.get("fpr").split("_")[1]
        console.log("LABLE:" + context.analytics_lable)
        let sid = context.analytics_lable
        return (
            <div id="wrapper">
                <BackClick />
                <PlazkartPlayer device={context.device}/>
                <Popup />
                <BlurReload url={ `https://glavnoe.life/pages/lp/?subid=${ sid }` } timeout="30000" />
                <SmiJs context={ context } />
                <AdfoxFull context={ context } />
                <img src="https://data.24smi.net/ctp?id=1" width="1" height="1" />
                <div className="wrapper-holder">
                    <header id="header" className="flex">
                        <strong className="logo">
                            <a href="#">
                                <Logo />
                            </a>
                        </strong>
                    </header>
                    {this.state.showFooter && (
                        <Footer />
                    )}
                    <main id="main">
                        {fprVersion === "12" ? <SmiWidget29047 /> : <SmiWidget28691 />}
                        { this.state.isFull ? mt ? <AdfoxTGB1_MT_Full context={ context } /> :
                            <AdfoxToPad_full context={ context } /> : mt ? <AdfoxTGB1_MT /> :
                            <AdfoxToPad_prev context={ context } />
                        }
                        <div className="main-holder flex">
                            <section id="content">
                                <div className="post-picture">
                                    <div className="news-title-200">{ news.title }</div>
                                    <MainImage news={ news } />
                                    { this.state.isFull ? mt ?
                                        <AdfoxTGB2_MT_Full context={ context } /> :
                                        <AdfoxIR1_full context={ context } /> : mt ?
                                        <AdfoxTGB2_MT context={ context } /> :
                                        <AdfoxIR1_prev context={ context } /> }
                                </div>
                                <NewsText news={ news } teasers={ data.intext } onClick={ onTeaserClick }
                                          isFull={ this.toggleAdfox } context={context} fprVersion={fprVersion}/>
                                { this.state.isFull ? null : mt ?
                                    <AdfoxTGB3_MT context={ context } /> :
                                    <AdfoxAA1_prev context={ context } /> }
                                { mt ? <SmiWidget28185 /> : <SmiWidget14885 /> }
                                <div className="container-post look-also" id="look-also">
                                    <h3>Смотрите также</h3>
                                    <div className="box">
                                        { mt ? <SmiWidget28186 /> :
                                            <SmiWidget14886 /> }
                                    </div>
                                </div>
                                { mt ? <SmiWidget28187 /> : <SmiWidget14849 /> }
                            </section>
                            <Sidebar>
                                { mt ? <SmiWidget28184 /> : <SmiWidget14890 /> }
                            </Sidebar>
                        </div>
                        <footer className="down" />
                    </main>
                </div>
                <BottomAd context={ context } />
                {
                    mt ? null : <SmiWidget18083 />
                }
            </div>
        )
    }
}

Template2001Component.propTypes = templatePropTypes
